// extracted by mini-css-extract-plugin
module.exports = {"root":"Posts-module--root--rPW-4","postsContainer":"Posts-module--postsContainer--2gRDn"};